export default __webpack_public_path__ + "static/media/astro1.331c3e0b.jpg";